import OrderCenterLayout from '../OrderCenter/OrderCenterLayout'
import React from 'react'
import clsx from 'clsx'
import QuickOrder from './QuickOrder'
import RecentlyViewedProductsCarousel from '@src/components/RecentlyViewedProductsCarousel/RecentlyViewedProductsCarousel'
import { AnalyticsDispType } from '@src/types/graphql-types'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import { useCurrentUser } from '@src/utils/useCurrentUser'
import getConfig from 'next/config'
import { QuickOrderModalContentType } from '@src/components/QuickOrder/utils'
import AddToOrder from '@src/components/AddToOrder'
import { Grid, Typography } from '@material-ui/core'
import { InfoBanner } from '@src/components/InfoBanner'
import { useCookies } from '@src/utils/cookies'
import {
  sendQuickOrderTracking,
  sendQuickOrderInteractionEvent,
} from '@src/utils/analytics'
import QuickOrderRecommendedProducts from './QuickOrderRecommendedProducts'

const {
  publicRuntimeConfig: { featureFlags },
} = getConfig()

const useStyles = makeStyles((theme) => ({
  addToCartSection: {
    marginTop: 0,
    [theme.breakpoints.up('sm')]: {
      marginTop: 40,
      marginBottom: theme.spacing(6),
    },
  },
  infoBannerGrid: {
    padding: theme.spacing(0, 4),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0),
      paddingInlineEnd: theme.spacing(6),
    },
  },
  container: {
    padding: theme.spacing(0, 4),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0),
    },
  },
  recentlyViewedProductsBannerSpacing: {
    marginTop: theme.spacing(10),
  },
}))

const QuickOrderLayout = () => {
  const classes = useStyles()
  const { addToCartSection } = classes
  const {
    isDejaEnabled,
    isB2BUser,
    userIsLoggedIn,
    isQuoteEnabled,
    userId = '',
  } = useCurrentUser()
  const showAddToOrder =
    isDejaEnabled && !isB2BUser && featureFlags.dejaQuickOrder
  const [cookies] = useCookies(['_ga'])
  const handleLearnMore = (linkUrl: string) => {
    sendQuickOrderTracking('get quote - learn more', cookies._ga, {
      clickType: 'need a quote : learn more',
      clickAction: 'learn more to create quote',
      component: 'body',
      elementType: 'link',
      linkText: 'learn more',
      linkUrl,
    })
  }

  const addToOrderContentTypes = [
    QuickOrderModalContentType.Order,
    QuickOrderModalContentType.SavedCart,
  ]

  if (isQuoteEnabled) {
    addToOrderContentTypes.push(QuickOrderModalContentType['Quote'])
  }

  addToOrderContentTypes.push(QuickOrderModalContentType['List'])

  const renderAddToOrder = () => (
    <AddToOrder contentTypes={addToOrderContentTypes} />
  )

  return (
    <OrderCenterLayout isNavEnabled={false} isQuickOrderLayout>
      <div className={classes.container}>
        <QuickOrder
          classes={{ addToCartSection }}
          sidebar={showAddToOrder ? renderAddToOrder() : <div />}
          heading={
            <Typography variant="h1">
              <FormattedMessage id="QUICK_ORDER" defaultMessage="Quick Order" />
            </Typography>
          }
          onTabClick={(tab: string, gaCookie: string | undefined) => {
            sendQuickOrderInteractionEvent(
              {
                action: `switch to ${tab}`,
                detail: tab === 'manual entry' ? 'bulk upload' : 'manual entry',
                component: 'body',
                elementType: 'tab',
                elementText: tab,
              },
              {
                eventCategory: 'quick order page',
                eventAction: tab,
                eventLabel: gaCookie,
                eventInteractionType: 0,
              }
            )
          }}
        />
      </div>
      {/* Info banner */}
      <Grid item xs={12} md={8} className={classes.infoBannerGrid}>
        <InfoBanner inlineLink onLearnMoreClick={handleLearnMore} />
      </Grid>
      {userIsLoggedIn ? (
        <QuickOrderRecommendedProducts participantId={userId} />
      ) : null}
      <RecentlyViewedProductsCarousel
        className={clsx({
          [classes.recentlyViewedProductsBannerSpacing]: !userIsLoggedIn,
        })}
        dispType={AnalyticsDispType.RecentlyViewedQuickOrder}
        parentPageName="quick order"
        parentPageNameDetail="quick order page"
      />
    </OrderCenterLayout>
  )
}

export default QuickOrderLayout
